import axios from "axios";
import { cabecalhosDesconto } from "./Desconto/contextoDesconto";

const API_CONFIG = process.env.REACT_APP_API_MODE
  ? process.env.REACT_APP_API_MODE === "production"
    ? process.env.REACT_APP_API_PRODUCAO || "http://ecfweb.gtech.site"
    : process.env.REACT_APP_API_MODE === "test"
    ? process.env.REACT_APP_API_TESTE || "http://teste.ecfweb.gtech.site"
    : process.env.REACT_APP_API_LOCALHOST || "http://127.0.0.1:8080"
  : process.env.REACT_APP_API_LOCALHOST || "http://127.0.0.1:8080";
const PATH_TOKEN = "/oauth/token";
const PATH_USUARIOS = "/usuarios";
const USUARIO_LOGADO = "usuario";
const ACCESS_TOKEN = "access_auth";
const REFRESH_TOKEN = "refresh_auth";
const customAxios = axios.create({
  baseURL: API_CONFIG,
});

// Log da configuração da API
console.log("=== CONFIGURAÇÃO DA API ===");
console.log("API_CONFIG:", API_CONFIG);
console.log("REACT_APP_API_MODE:", process.env.REACT_APP_API_MODE);
console.log("REACT_APP_API_LOCALHOST:", process.env.REACT_APP_API_LOCALHOST);
console.log("==========================");
const DISABLE_AUTO_RELOAD_ON_401 =
  String(
    process.env.REACT_APP_DISABLE_AUTO_RELOAD_ON_401 || ""
  ).toLowerCase() === "true";

const recortar = (s, max) => (!s ? s : s.length <= max ? s : s.substring(0, max));

// Envia o erro de API para /admin/log-erro/frontend usando o proprio customAxios.
// Marca a request com __isErroReport para o interceptor de resposta nao reportar
// de novo se o proprio POST falhar (evita loop). Reporta so 5xx e falha de rede.
const reportarErroApi = (error, originalRequest) => {
  try {
    if (originalRequest && originalRequest.__isErroReport) return;
    const status = error.response && error.response.status;
    const semResposta = !error.response;
    if (!semResposta && !(status >= 500)) return;

    const dados = error.response && error.response.data;
    const msgBackend =
      (dados && (dados.message || dados.error || dados.mensagem)) ||
      error.message ||
      "Erro de comunicação com o servidor";
    const url = originalRequest && originalRequest.url;
    const metodo = originalRequest && originalRequest.method;

    customAxios.post(
      "/admin/log-erro/frontend",
      {
        mensagem: recortar(
          (status ? "[" + status + "] " : "[rede] ") + msgBackend,
          1000
        ),
        stacktrace: recortar(
          (metodo ? metodo.toUpperCase() + " " : "") +
            (url || "") +
            (dados ? "\n\n" + JSON.stringify(dados) : ""),
          2000
        ),
        endpoint: url || "",
        origem: "api",
      },
      { __isErroReport: true }
    ).catch(() => {});
  } catch (e) {
    // Nunca derruba a UI por causa do report.
  }
};

// --- Log bruto AO VIVO (Tarefa-19336) ---
// Publica no console ao vivo CADA chamada de API que o front faz, para o admin
// ver tudo o que o sistema dispara em tempo real na tela "Visualizar Log".
//
// IMPORTANTE: a tela de Log fica em OUTRA ABA do navegador (cada aba tem seu
// proprio JS), entao nao da para depender de um flag local "tela aberta". Por
// isso publicamos SEMPRE; quem decide guardar e o BACKEND: ele so adiciona ao
// buffer se houver uma sessao de log ativa (empresa+usuario) — senao descarta de
// imediato. Assim, qualquer aba alimenta o log enquanto a tela estiver aberta.
// Nunca publica as proprias rotas do log (evita loop).
export const setLogAoVivoAtivo = () => {}; // mantido por compat; nao usado

const ehRotaLog = (url) => typeof url === "string" && url.includes("admin/log-erro");

export const publicarAoVivoFront = (evento) => {
  try {
    const payload = typeof evento === "string"
      ? { mensagem: recortar(evento, 1000), origem: "front", stacktrace: null }
      : {
        mensagem: recortar(evento.mensagem, 1000),
        origem: evento.origem || "front",
        stacktrace: evento.stacktrace || null,
        endpoint: evento.endpoint || "",
        metodo: evento.metodo || "",
        statusHttp: evento.statusHttp || null,
        requestId: evento.requestId || "",
      };
    customAxios.post(
      "/admin/log-erro/ao-vivo/frontend",
      payload,
      { __isErroReport: true, __isLogAoVivo: true }
    ).catch(() => {});
  } catch (e) { /* nunca derruba a UI */ }
};

class jwtService {
  authTokenRequest = null;

  init() {
    this.setInterceptors();
  }

  signInWithUsernameAndPassword = (email, password) => {
    this.setSession(null);
    return new Promise((resolve, reject) => {
      this.login(email, password)
        .then((response) => {
          if (response.data) {
            this.setTokens(response);
            this.getUserData().then((response) => {
              this.setSession(response);
              resolve(response.data);
            });
          } else {
            reject(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  signInAdminWithUsernameAndPassword = (email, password) => {
    this.setSession(null);
    return new Promise((resolve, reject) => {
      this.login(email, password)
        .then((response) => {
          if (response.data) {
            this.setTokens(response);
            this.getUserData().then((response) => {
              this.setSession(response);
              resolve(response.data);
            });
          } else {
            reject(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  getUserData = async () => {
    return customAxios.get("/user-auth");
  };

  login = async (email, password) => {
    var reqData = `grant_type=password&username=${email}&password=${password}`;
    return axios.request({
      url: PATH_TOKEN,
      method: "post",
      baseURL: API_CONFIG,
      auth: {
        username: "webGtechEcfWeb", // This is the client_id
        password: "g2010tech", // This is the client_secret
      },
      data: reqData,
    });
  };

  refreshToken = async (error) => {
    var reqData = `grant_type=refresh_token&refresh_token=${this.getRefreshToken()}`;
    return axios.request({
      url: PATH_TOKEN,
      method: "post",
      baseURL: API_CONFIG,
      auth: {
        username: "webGtechEcfWeb", // This is the client_id
        password: "g2010tech", // This is the client_secret
      },
      data: reqData,
    });
  };

  setTokens = (response) => {
    if (response && response.data) {
      localStorage.setItem(
        ACCESS_TOKEN,
        JSON.stringify(response.data.access_token)
      );
      localStorage.setItem(
        REFRESH_TOKEN,
        JSON.stringify(response.data.refresh_token)
      );
    } else {
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
    }
  };

  setSession = (response) => {
    if (response && response.data) {
      this.setUsuarioLogado(response.data);
    } else {
      localStorage.removeItem(USUARIO_LOGADO);
    }
  };

  logout = () => {
    this.setSession(null);
  };

  setEmpresaLogada = (usuario, empresa) => {
    return new Promise((resolve, reject) => {
      customAxios
        .put(`${PATH_USUARIOS}/${usuario.codigo}/set_empresa_logada`, {
          idEmpresa: empresa.codigo,
        })
        .then((response) => {
          localStorage.setItem(USUARIO_LOGADO, JSON.stringify(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  };

  setUsuarioLogado = (data) => {
    localStorage.setItem(USUARIO_LOGADO, JSON.stringify(data));
  };
  
  getUsuarioLogado = () => {
    return JSON.parse(localStorage.getItem(USUARIO_LOGADO));
  };

  getAccessToken = () => {
    return JSON.parse(localStorage.getItem(ACCESS_TOKEN));
  };

  getRefreshToken = () => {
    return JSON.parse(localStorage.getItem(REFRESH_TOKEN));
  };

  getUrlAvatar = (avatar) =>{
    if (!avatar) return null;
    const isAbsolute =
      typeof avatar === "string" && /^https?:\/\//i.test(avatar);
    const url = isAbsolute ? avatar : `${API_CONFIG}${avatar}`;
    return `${url}?time=${new Date().getTime()}`;
  };

  getUrlLogo = (logo) => {
    if (!logo) return null;
    const isAbsolute = typeof logo === "string" && /^https?:\/\//i.test(logo);
    const url = isAbsolute ? logo : `${API_CONFIG}${logo}`;
    const finalUrl = `${url}?time=${new Date().getTime()}`;
    return finalUrl;
  };

  getAuthToken = () => {
    if (!this.authTokenRequest) {
      this.authTokenRequest = this.refreshToken();
      this.authTokenRequest.then(
        this.resetAuthTokenRequest,
        this.resetAuthTokenRequest
      );
    }

    return this.authTokenRequest;
  };

  resetAuthTokenRequest = () => {
    this.authTokenRequest = null;
  };

  setInterceptors = () => {
    customAxios.interceptors.request.use(
      async (config) => {
        const userToken = await this.getAccessToken();
        const usuarioLogado = await this.getUsuarioLogado();
        if (config.contextoEmpresaEsperado && (
          usuarioLogado?.adminLogin ||
          String(usuarioLogado?.codigo) !== String(config.contextoEmpresaEsperado.usuarioCodigo) ||
          String(usuarioLogado?.empresaLogada?.codigo) !== String(config.contextoEmpresaEsperado.empresaCodigo)
          || (config.contextoEmpresaEsperado.empresaId != null
            && String(usuarioLogado?.empresaLogada?.id) !== String(config.contextoEmpresaEsperado.empresaId))
          || (config.contextoEmpresaEsperado.grupoId != null
            && String(usuarioLogado?.empresaLogada?.grupoId) !== String(config.contextoEmpresaEsperado.grupoId))
        )) {
          throw new axios.Cancel("A empresa ou o usuário mudou antes da execução.");
        }
        config.headers.Authorization = `Bearer ${userToken}`;
        if(usuarioLogado && usuarioLogado.empresaLogada) {
          config.headers = {
            ...config.headers,
            ...{
              "empresa-id": usuarioLogado.empresaLogada.codigo,
            },
          };
        }
        // Aprovação de desconto da venda que está sendo gravada (ver contextoDesconto).
        const desconto = cabecalhosDesconto(config);
        if (desconto) {
          config.headers = { ...config.headers, ...desconto };
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    customAxios.interceptors.response.use(
      (response) => {
        // Log bruto ao vivo: registra cada chamada de API concluida (menos as do
        // proprio log, para nao gerar loop).
        try {
          const cfg = response.config || {};
          if (!cfg.__isLogAoVivo && !ehRotaLog(cfg.url)) {
            const m = (cfg.method ? cfg.method.toUpperCase() : "GET");
            const st = response.status;
            const requestId = response.headers && (response.headers["x-request-id"] || response.headers["request-id"]);
            publicarAoVivoFront({
              mensagem: `${m} ${cfg.url} [${st}]`,
              origem: "frontend",
              endpoint: cfg.url,
              metodo: m,
              statusHttp: st,
              requestId,
            });
          }
        } catch (e) { /* ignore */ }
        return response;
      },
      async (error) => {
        if (axios.isCancel(error)) throw error;
        const originalRequest = error.config;
        // Log bruto ao vivo: registra tambem as chamadas que falharam (inclui 4xx
        // de validacao, que e justamente o que o suporte quer ver).
        try {
          if (originalRequest && !originalRequest.__isLogAoVivo && !ehRotaLog(originalRequest.url)) {
            const m = (originalRequest.method ? originalRequest.method.toUpperCase() : "GET");
            const st = error.response ? error.response.status : "rede";
            const dados = error.response && error.response.data;
            const msg = (dados && (dados.message || dados.error || dados.mensagem)) || error.message || "";
            const requestId = error.response && error.response.headers &&
              (error.response.headers["x-request-id"] || error.response.headers["request-id"]);
            publicarAoVivoFront({
              mensagem: `${m} ${originalRequest.url} [${st}] ${msg}`,
              origem: "frontend",
              endpoint: originalRequest.url,
              metodo: m,
              statusHttp: typeof st === "number" ? st : null,
              requestId,
            });
          }
        } catch (e) { /* ignore */ }
        // Reporta no Visualizar Log os erros de servidor (5xx) e falhas de rede
        // (sem resposta) com a mensagem real vinda do backend, em vez do generico
        // "Request failed with status code 500" do axios. Erros 4xx de validacao
        // (400/422) ficam de fora: sao esperados e ja tratados na tela.
        reportarErroApi(error, originalRequest);
        if (error.response && error.response.status === 401) {
          if(!originalRequest.__isRetryRequest) {
            return this.getAuthToken()
              .then((response) => {
                this.setTokens(response);
                error.config.__isRetryRequest = true;
                return customAxios(originalRequest);
              })
              .catch((err) => {
                const isValidationRequest =
                  originalRequest.url &&
                  (originalRequest.url.includes("/find_by_cpf") ||
                    originalRequest.url.includes("/find_by_cnpj") ||
                    originalRequest.url.includes("/cep/") ||
                    originalRequest.url.includes("/preferencias-etiquetas"));

                if (!isValidationRequest) {
                this.setSession(null);
                this.setTokens(null);
                  if (!DISABLE_AUTO_RELOAD_ON_401) {
                window.location.reload();
                  } else {
                    console.warn(
                      "401 recebido - auto-reload desativado (REACT_APP_DISABLE_AUTO_RELOAD_ON_401=true)"
                    );
                  }
                }
                throw err;
              });
            }else{
            const isValidationRequest =
              originalRequest.url &&
              (originalRequest.url.includes("/find_by_cpf") ||
                originalRequest.url.includes("/find_by_cnpj") ||
                originalRequest.url.includes("/cep/") ||
                originalRequest.url.includes("/preferencias-etiquetas"));

            if (!isValidationRequest) {
              this.setSession(null);
              this.setTokens(null);
              if (!DISABLE_AUTO_RELOAD_ON_401) {
              window.location.reload();
              } else {
                console.warn(
                  "401 recebido (retry) - auto-reload desativado (REACT_APP_DISABLE_AUTO_RELOAD_ON_401=true)"
                );
              }
            }
            }
        }
        throw error;
      }
    );
  };

  getInterceptor() {
    return customAxios;
  }
}

const instance = new jwtService();

export default instance;
